import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import i18n from "i18next";
import Select from "react-select";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import EmployeeTrainings from "components/widgets/training/EmployeeTrainings";
import { api } from "api";

class EmployeeTrainingManagement extends Component {
  state = {
    selectedDepartment: null,
    selectedEmployee: this.props.profile.general.id,
    employeeOptionsList: [],
    isManager: localStorage.getItem("roles").includes("Manager"),
    selectedJoined: null,
    selectedSuccess: null,
    selectedTrainingMethod: null,
    selectedTrainingArea: null,
    trainingAreas: [],
    trainings: [],
    employeePosition: null,
    selectedPositionTrainingTypes: null,
    selectedTechnicalPositionTrainingTypes: null
  };

  fetchTrainingAreas = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/employee-training-management/get-training-areas`)
      .then((response) => {
        const options = [];
        response.data.data.trainingAreas[1033].forEach((value) => {
          options.push({ value: value.id, label: value.name });
        });
        this.setState({
          trainingAreas: options,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  fetchEmployees = () => {
    if (this.state.isManager) {
      this.props.onProcessBegin();
      api
        .get(
          `/api/employee-training-management/get-training-management-employees/${this.state.selectedDepartment}`
        )
        .then((response) => {
          const options = [];
          response.data.data.employees.forEach((value) => {
            options.push({
              value: value.id,
              label: value.fullname,
              position: value.position,
            });
          });
          this.setState({
            employeeOptionsList: options,
            employeePosition: response.data.data.employees.find(
              (w) => w.id == this.state.selectedEmployee
            )?.position?.name,
          });
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.props.onProcessEnd();
        });
    }
  };

  componentDidMount = () => {
    this.props.onProcessBegin();
    this.fetchTrainingAreas();
    if (this.props.guide.length !== 0 && this.props.profile.general.id) {
      this.setSelectedEmployeeAndDepartment();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.guide !== this.props.guide) {
      this.setSelectedEmployeeAndDepartment();
    }
    if (prevState.selectedDepartment !== this.state.selectedDepartment) {
      this.fetchEmployees();
    }
    if (prevState.selectedEmployee !== this.state.selectedEmployee) {
      this.setState({
        employeePosition: this.state.employeeOptionsList.find(
          (w) => w.value == this.state.selectedEmployee
        )?.position?.name,
      });
    }
  }

  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = () => {
    this.props.onProcessEnd();
  };
  onError = (err) => {
    this.props.onProcessEnd();
  };

  handleTrainingAreaSelect = (e) => {
    this.setState({ selectedTrainingArea: e.value });
  };

  handleTrainingMethodSelect = (e) => {
    this.setState({ selectedTrainingMethod: e.value });
  };

  handleJoinedSelect = (e) => {
    this.setState({ selectedJoined: e.value });
  };

  handleSuccessSelect = (e) => {
    this.setState({ selectedSuccess: e.value });
  };

  handleDepartmentSelect = (e) => {
    this.setState({ selectedDepartment: e.value, selectedEmployee: null });
  };

  handlePositionTrainingTypeSelect = (e) => {
    if (e != null) {
      this.setState({ selectedPositionTrainingTypes: e.map((w) => w.value) });
    } else {
      this.setState({ selectedPositionTrainingTypes: null });
    }
  };

  handleTechnicalPositionPromotionTypeSelect = (e) => {
    if (e != null) {
      this.setState({ selectedTechnicalPositionTrainingTypes: e.map(w => w.value) })
    }
    else {
      this.setState({ selectedTechnicalPositionTrainingTypes: null })
    }
  }

  handleClearFilters = () => {
    this.setState({
      selectedJoined: null,
      selectedSuccess: null,
      selectedTrainingMethod: null,
      selectedTrainingArea: null,
      selectedPositionTrainingTypes: null,
      selectedTechnicalPositionTrainingTypes: null
    });
  };

  handleEmployeeSelect = (e) => {
    this.setState({ selectedEmployee: e.value });
  };

  setSelectedEmployeeAndDepartment = () => {
    let selectedDepartment = null;
    const selectedEmployee = this.props.match.params
      ? this.props.match.params.userid
        ? this.props.match.params.userid
        : this.props.profile.general.id
      : this.props.profile.general.id;

    const employeeOnGuide = this.props.guide.data.find(
      (c) => c.id === selectedEmployee
    );
    console.log(employeeOnGuide)

    if (employeeOnGuide) {
      selectedDepartment = employeeOnGuide.serviceType.value
        ? employeeOnGuide.serviceType.value
        : null;
    } else {
      //default olarak satış seçilsin
      selectedDepartment = 50022; //satış
    }

    this.fetchEmployees();

    this.setState({ selectedEmployee: selectedEmployee, selectedDepartment });
  };

  renderPosition = () => {
    if (!this.state.isManager) {
      return this.props.profile.general.positionName;
    }
    return this.state.employeePosition;
  };

  renderEmployeesCombo = () => {
    const isDisabled = !this.state.isManager;
    if (isDisabled) {
      const options = [
        {
          value: this.props.profile.general.id,
          label: this.props.profile.general.fullname,
        },
      ];
      return (
        <Select
          placeholder={i18n.t("10521")}
          isDisabled={isDisabled}
          options={options}
          value={options.find((o) => o.value === this.props.profile.general.id)}
        />
      );
    }
    return (
      <Select
        placeholder={i18n.t("10521")}
        label="ee"
        options={this.state.employeeOptionsList}
        onChange={(e) => this.handleEmployeeSelect(e)}
        value={
          this.state.selectedEmployee
            ? this.state.employeeOptionsList.find(
              (o) => o.value === this.state.selectedEmployee
            )
            : null
        }
      />
    );
  };

  renderDepartmentCombo = () => {
    const isDisabled = !this.state.isManager;
    /*
          MechanicalS = 10049;
          Body / PaintS = 10050
          SalesS = 10047
          Service Administration = 10048
        */
    const options = [
      { value: "50020", label: i18n.t("10049") },
      { value: "50021", label: i18n.t("10050") },
      { value: "50022", label: i18n.t("10047") },
      { value: "50023", label: i18n.t("10048") },
    ];

    return (
      <Select
        placeholder={i18n.t("10521")}
        isDisabled={isDisabled}
        options={options}
        onChange={(e) => this.handleDepartmentSelect(e)}
        value={options.find(
          (o) => o.value === String(this.state.selectedDepartment)
        )}
      />
    );
  };

  renderJoinedCombo = () => {
    const options = [
      { value: false, label: i18n.t("10505") },
      { value: true, label: i18n.t("10504") },
    ];

    return (
      <Select
        placeholder={i18n.t("10521")}
        isDisabled={false}
        options={options}
        onChange={(e) => this.handleJoinedSelect(e)}
        value={
          options.find((o) => o.value === this.state.selectedJoined) ?? null
        }
      />
    );
  };

  renderSuccessCombo = () => {
    const options = [
      { value: false, label: i18n.t("10505") },
      { value: true, label: i18n.t("10504") },
    ];

    return (
      <Select
        placeholder={i18n.t("10521")}
        isDisabled={false}
        options={options}
        onChange={(e) => this.handleSuccessSelect(e)}
        value={
          options.find((o) => o.value === this.state.selectedSuccess) ?? null
        }
      />
    );
  };

  renderTrainingMethodCombo = () => {
    const options = [
      { value: "1", label: i18n.t("10733") },
      { value: "2", label: i18n.t("10710") },
      { value: "3", label: i18n.t("10711") },
    ];

    return (
      <Select
        placeholder={i18n.t("10521")}
        isDisabled={false}
        options={options}
        onChange={(e) => this.handleTrainingMethodSelect(e)}
        value={
          options.find(
            (o) => o.value === String(this.state.selectedTrainingMethod)
          ) ?? null
        }
      />
    );
  };

  renderTrainingAreasCombo = () => {
    return (
      <Select
        placeholder={i18n.t("10521")}
        isDisabled={false}
        options={this.state.trainingAreas}
        onChange={(e) => this.handleTrainingAreaSelect(e)}
        value={
          this.state.trainingAreas.find(
            (o) => o.value === String(this.state.selectedTrainingArea)
          ) ?? null
        }
      />
    );
  };

  renderPositionTrainingTypeCombo = () => {
    const options = [
      { value: "0", label: i18n.t("10730") },
      { value: "1", label: i18n.t("10731") },
      { value: "2", label: i18n.t("10732") },
    ];
    const value =
      this.state.selectedPositionTrainingTypes != null
        ? options.find(
          (o) => o.value === this.state.selectedPositionTrainingTypes
        )
        : null;
    return (
      <Select
        placeholder={i18n.t("10521")}
        isMulti
        isDisabled={false}
        options={options}
        onChange={(e) => this.handlePositionTrainingTypeSelect(e)}
        value={value}
      />
    );
  };

  renderTechnicalPositionPromotionTypeCombo = () => {
    const options = [
      { value: "1", label: i18n.t("10728") },
      { value: "2", label: i18n.t("10729") }
    ];
    const value = this.state.selectedTechnicalPositionTrainingTypes != null ? options.find((o) => o.value === this.state.selectedTechnicalPositionTrainingTypes) : null;
    return (
      <Select
        placeholder={i18n.t("10521")}
        isMulti
        isDisabled={false}
        options={options}
        onChange={(e) => this.handleTechnicalPositionPromotionTypeSelect(e)}
        value={value}
      />
    );
  };

  renderTabbedContent = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <EmployeeTrainings
          selectedFilters={{
            selectedEmployee: this.state.selectedEmployee,
            selectedJoined: this.state.selectedJoined,
            selectedSuccess: this.state.selectedSuccess,
            selectedTrainingMethod: this.state.selectedTrainingMethod,
            selectedTrainingArea: this.state.selectedTrainingArea,
            selectedPositionTrainingTypes: this.state.selectedPositionTrainingTypes,
            selectedTechnicalPositionTrainingTypes: this.state.selectedTechnicalPositionTrainingTypes
          }}
          isManager={this.state.isManager} isMechanical={this.state.selectedDepartment == "50020"}
        />
      </div>
    );
  };

  renderClearFilterButton = () => {
    return (
      <button
        className="clear-filter-button"
        onClick={() => this.handleClearFilters()}
      >
        <Trans desc="Filtreleri temizle">10721</Trans>
      </button>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4 d-none d-sm-none d-md-flex d-lg-flex">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="/employee-training-management">
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Çalışan Eğitim Yönetimi">10707</Trans>
                </li>
              </ul>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4 d-flex d-sm-flex d-md-none d-lg-none">
              <div className="sssBaslik">
                <Trans desc="Çalışan Eğitim Yönetimi">10707</Trans>
              </div>
            </div>
          </div>
          <div className="row calculateArea">
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 my-1">
              <div className="ml-2">
                <label htmlFor="departmanSeciniz" className="filterHeader">
                  <Trans desc="Departman Seçiniz">10138</Trans>:
                </label>
                {this.renderDepartmentCombo()}
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
              <div className="ml-2">
                <label htmlFor="seciliPersonel" className="filterHeader">
                  <Trans desc="Seçili Personel">10139</Trans>:
                </label>
                {this.renderEmployeesCombo()}
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 my-1">
              <div>
                <label htmlFor="seciliPersonel" className="pl-2">
                  <Trans desc="Pozisyon">10140</Trans>:
                </label>
                <p id="seciliPersonel" className="mb-0 pl-2 positionName">
                  {this.renderPosition()}
                </p>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-2 my-1">
              <div className="ml-2">
                <label htmlFor="eğitimAlanı" className="filterHeader">
                  <Trans desc="Eğitim Alanı">10713</Trans>:
                </label>
                {this.renderTrainingAreasCombo()}
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-2 my-1">
              <div className="ml-2">
                <label htmlFor="eğitimMethodu" className="filterHeader">
                  <Trans desc="Eğitim Methodu">10712</Trans>:
                </label>
                {this.renderTrainingMethodCombo()}
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-1 my-1">
              <div className="ml-2">
                <label htmlFor="katılım" className="filterHeader">
                  <Trans desc="Katılım">10708</Trans>:
                </label>
                {this.renderJoinedCombo()}
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-1 my-1">
              <div className="ml-2">
                <label htmlFor="başarı" className="filterHeader">
                  <Trans desc="Başarı">10709</Trans>:
                </label>
                {this.renderSuccessCombo()}
              </div>
            </div>
            <div className={`col-xs-12 col-sm-12 my-1 ${this.state.selectedDepartment == "50020" ? "col-lg-2 col-md-4" : "col-lg-5 col-md-9"}`}>
              <div className="ml-2">
                <label htmlFor="poziyon eğitim türü" className='filterHeader'>
                  <Trans desc="Pozisyon eğitim türü">10722</Trans>:
                </label>
                {this.renderPositionTrainingTypeCombo()}
              </div>
            </div>
            {
              this.state.selectedDepartment == "50020" ?
                <div className="col-xs-12 col-sm-12 col-md-5 col-lg-3 my-1">
                  <div className="ml-2">
                    <label htmlFor="teknik pozisyon yükselme eğitimleri" className='filterHeader'>
                      <Trans desc="Teknik pozisyon yükselme eğitimleri">10727</Trans>:
                    </label>
                    {this.renderTechnicalPositionPromotionTypeCombo()}
                  </div>
                </div> : null
            }
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-1 my-1">
              {this.renderClearFilterButton()}
            </div>
          </div>
          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    guide: state.guide,
    profile: state.profile,
  };
};
export default connect(
  mapStateToProps,
  {}
)(requireAuth(containsLongRunningProcess(EmployeeTrainingManagement)));
